import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useClassName } from '../../hooks';
import { Typography } from '../Typography/Typography';
import { Fetching } from './components';
import { useTextColor, useIconColor } from './hooks';
import { Group } from './components/Group/Group';
import { Icon } from '../Icon/Icon';
import './Button.scss';
/**
 * General purpose button component.
 */
export const Button = ({ children, onClick, size = 'md', variant = 'primary', disabled = false, fetching, loading, testId, icon, }) => {
    const className = useClassName({
        name: 'button',
        prefixed: true,
    }, size, variant, disabled && 'disabled', loading && 'loading', fetching && 'fetching');
    const textContainerClassName = useClassName('text-container', 'fetching');
    const textColor = useTextColor({ disabled, fetching, loading, variant });
    const iconColor = useIconColor({ variant, textColor, disabled, fetching, loading });
    return (_jsxs("button", { "data-testid": testId, className: className, onClick: onClick, disabled: disabled, children: [_jsxs("div", { className: textContainerClassName, children: [icon && _jsx(Icon, { name: icon, color: iconColor, size: 'md' }), _jsx(Typography.Text, { "data-testid": 'button-', whiteSpace: 'nowrap', size: 'md', color: textColor, weight: 'medium', Tag: 'div', pointerEvents: 'none', children: children })] }), fetching && !loading && !disabled && _jsx(Fetching, { variant: variant })] }));
};
Button.Group = Group;
